module.exports = __webpack_public_path__ + "static/media/station.c4724cdd.png";